/* feedback-options-modal.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./feedback-options-modal.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import EditIcon from '@atlaskit/icon/core/migration/edit';
import EditorFeedbackIcon from '@atlaskit/icon/core/migration/feedback--editor-feedback';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Box, Flex, Pressable } from '@atlaskit/primitives/compiled';
import { messages } from './messages';
var styles = {
  feedbackOptionsWrapper: "_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _n3td1ejb",
  feedbackOption: "_2rko12b0 _1bsb1osq _4t3i8vuz _bfhksm61 _irr31dpa",
  feedbackOptionIconWrapper: "_2rkolb4i _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg",
  feedbackOptionText: "_11c82smr _syazi7uo",
  feedbackOptionSubText: "_11c81o8v _syaz1rpy"
};
export var FeedbackOptionsModal = function FeedbackOptionsModal(_ref) {
  var setShowFeedbackOptionsModal = _ref.setShowFeedbackOptionsModal,
    setShowEditDefinitionModal = _ref.setShowEditDefinitionModal,
    setShowFeedbackModal = _ref.setShowFeedbackModal,
    editDefinitionEnabled = _ref.editDefinitionEnabled;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: function onClose() {
      return setShowFeedbackOptionsModal(false);
    },
    shouldReturnFocus: false
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    hasCloseButton: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, formatMessage(editDefinitionEnabled ? messages.definition_footer_feedback_options_modal_header : messages.definition_footer_feedback_options_modal_header_feedback_only))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.feedbackOptionsWrapper
  }, editDefinitionEnabled && /*#__PURE__*/React.createElement(Pressable, {
    xcss: styles.feedbackOption,
    onClick: function onClick() {
      setShowFeedbackOptionsModal(false);
      setShowEditDefinitionModal(true);
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "color.background.accent.blue.subtle",
    xcss: styles.feedbackOptionIconWrapper
  }, /*#__PURE__*/React.createElement(EditIcon, {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: "",
    color: "var(--ds-icon-inverse, #FFFFFF)"
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: "space.025",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.feedbackOptionText
  }, formatMessage(messages.definition_footer_feedback_options_edit_definition_option)), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.feedbackOptionSubText
  }, formatMessage(messages.definition_footer_feedback_options_edit_definition_option_subtext))))), /*#__PURE__*/React.createElement(Pressable, {
    xcss: styles.feedbackOption,
    onClick: function onClick() {
      setShowFeedbackOptionsModal(false);
      setShowFeedbackModal(true);
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "color.background.accent.blue.subtle",
    xcss: styles.feedbackOptionIconWrapper
  }, /*#__PURE__*/React.createElement(EditorFeedbackIcon, {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: "",
    color: "var(--ds-icon-inverse, #FFFFFF)"
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: "space.025",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.feedbackOptionText
  }, formatMessage(messages.definition_footer_feedback_options_leave_feedback_option)), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.feedbackOptionSubText
  }, formatMessage(messages.definition_footer_feedback_options_leave_feedback_option_subtext))))))));
};